import script from "./TaskAssignee.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskAssignee.vue?vue&type=script&setup=true&lang=js"

import "@/assets/sass/components/task-ui.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__